import React from 'react';
import { motion } from 'framer-motion';
export function TermsConditionsPage() {
  return <main className="flex-1 bg-background" data-id="element-466">
      {/* Hero Section */}
      <section className="relative pt-16 pb-12 lg:pt-24 lg:pb-16 bg-gradient-to-br from-primary/5 to-accent/5" data-id="element-467">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-468">
          <motion.h1 initial={{
          opacity: 0,
          y: -20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6
        }} className="text-4xl md:text-5xl font-bold text-slate-dark mb-6" data-id="element-469">
            Terms & Conditions
          </motion.h1>
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="text-xl text-slate-600 max-w-2xl mx-auto leading-relaxed" data-id="element-470">
            These terms govern your use of Bluecore's ebook subscription
            service.
          </motion.p>
        </div>
      </section>

      {/* Content Section */}
      <section className="py-20 bg-white" data-id="element-471">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-472">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} className="space-y-12" data-id="element-473">
            <div data-id="element-474">
              <h2 className="text-2xl font-bold text-slate-dark mb-4" data-id="element-475">
                1. Introduction
              </h2>
              <p className="text-lg text-slate-600 leading-relaxed" data-id="element-476">
                Welcome to Bluecore. By accessing our website and using our
                services, you agree to be bound by these Terms & Conditions. If
                you do not agree with any part of these terms, you must not use
                our service.
              </p>
            </div>

            <div data-id="element-477">
              <h2 className="text-2xl font-bold text-slate-dark mb-4" data-id="element-478">
                2. Website Ownership
              </h2>
              <p className="text-lg text-slate-600 leading-relaxed" data-id="element-479">
                This website and the Bluecore service are owned and operated by
                Bluecore. All rights reserved.
              </p>
            </div>

            <div data-id="element-480">
              <h2 className="text-2xl font-bold text-slate-dark mb-4" data-id="element-481">
                3. Service Description
              </h2>
              <p className="text-lg text-slate-600 leading-relaxed mb-4" data-id="element-482">
                Bluecore provides a subscription-based platform for accessing
                curated digital ebooks. Our service is cloud-based and requires
                no downloads.
              </p>
              <p className="text-lg text-slate-600 leading-relaxed" data-id="element-483">
                Access to content is determined by your subscription tier
                (Silver, Gold, or Platinum). We reserve the right to modify,
                suspend, or discontinue any part of the service at any time.
              </p>
            </div>

            <div data-id="element-484">
              <h2 className="text-2xl font-bold text-slate-dark mb-4" data-id="element-485">
                4. Subscription Terms
              </h2>
              <ul className="space-y-3 text-lg text-slate-600 leading-relaxed list-disc pl-6" data-id="element-486">
                <li data-id="element-487">Subscriptions are billed annually in advance.</li>
                <li data-id="element-488">
                  Your subscription will automatically renew at the end of each
                  billing period unless cancelled.
                </li>
                <li data-id="element-489">
                  If you cancel, your access will continue until the end of your
                  current billing period.
                </li>
              </ul>
            </div>

            <div data-id="element-490">
              <h2 className="text-2xl font-bold text-slate-dark mb-4" data-id="element-491">
                5. Payment Terms
              </h2>
              <p className="text-lg text-slate-600 leading-relaxed mb-4" data-id="element-492">
                Payments are processed securely via Stripe. You authorize us to
                charge your chosen payment method for the annual subscription
                fee.
              </p>
              <p className="text-lg text-slate-600 leading-relaxed" data-id="element-493">
                Prices are subject to change. We will provide at least 30 days'
                notice of any price changes. Failed payments may result in
                immediate suspension of your service access.
              </p>
            </div>

            <div data-id="element-494">
              <h2 className="text-2xl font-bold text-slate-dark mb-4" data-id="element-495">
                6. User Responsibilities
              </h2>
              <p className="text-lg text-slate-600 leading-relaxed mb-4" data-id="element-496">
                You agree to:
              </p>
              <ul className="space-y-3 text-lg text-slate-600 leading-relaxed list-disc pl-6" data-id="element-497">
                <li data-id="element-498">
                  Maintain the confidentiality of your account credentials.
                </li>
                <li data-id="element-499">Provide accurate and up-to-date information.</li>
                <li data-id="element-500">Not share your account access with others.</li>
                <li data-id="element-501">Comply with our Acceptable Use Policy.</li>
              </ul>
            </div>

            <div data-id="element-502">
              <h2 className="text-2xl font-bold text-slate-dark mb-4" data-id="element-503">
                7. Acceptable Use
              </h2>
              <p className="text-lg text-slate-600 leading-relaxed" data-id="element-504">
                Our service is for personal use only (unless you have a specific
                business plan). You must not redistribute, copy, scrape, or
                attempt to download ebooks for permanent storage. Any automated
                access or misuse of the service is strictly prohibited.
              </p>
            </div>

            <div data-id="element-505">
              <h2 className="text-2xl font-bold text-slate-dark mb-4" data-id="element-506">
                8. Intellectual Property
              </h2>
              <p className="text-lg text-slate-600 leading-relaxed" data-id="element-507">
                All ebooks and content provided through Bluecore are licensed,
                not sold. Copyright remains with the respective publishers and
                authors. You are granted a limited, non-exclusive,
                non-transferable license to access the content for personal
                reading only.
              </p>
            </div>

            <div data-id="element-508">
              <h2 className="text-2xl font-bold text-slate-dark mb-4" data-id="element-509">
                9. Limits of Liability
              </h2>
              <p className="text-lg text-slate-600 leading-relaxed" data-id="element-510">
                The service is provided "as is" without warranties of any kind.
                Bluecore shall not be liable for any indirect, incidental, or
                consequential damages arising from your use of the service. Our
                total liability shall be limited to the amount you paid for the
                service in the 12 months preceding the claim.
              </p>
            </div>

            <div data-id="element-511">
              <h2 className="text-2xl font-bold text-slate-dark mb-4" data-id="element-512">
                10. Dispute Resolution
              </h2>
              <p className="text-lg text-slate-600 leading-relaxed" data-id="element-513">
                These terms are governed by the laws of the United Kingdom. Any
                disputes shall be resolved through amicable negotiation where
                possible, or through the courts of the United Kingdom.
              </p>
            </div>

            <div data-id="element-514">
              <h2 className="text-2xl font-bold text-slate-dark mb-4" data-id="element-515">
                11. Changes to Terms
              </h2>
              <p className="text-lg text-slate-600 leading-relaxed" data-id="element-516">
                We may update these terms from time to time. Continued use of
                the service constitutes acceptance of the new terms. Significant
                changes will be notified via email.
              </p>
            </div>

            <div data-id="element-517">
              <h2 className="text-2xl font-bold text-slate-dark mb-4" data-id="element-518">
                12. Privacy
              </h2>
              <p className="text-lg text-slate-600 leading-relaxed" data-id="element-519">
                Your use of the service is also governed by our Privacy & Cookie
                Policy, which explains how we handle your personal data.
              </p>
            </div>

            <div className="bg-slate-50 p-6 rounded-xl border border-slate-100" data-id="element-520">
              <h2 className="text-xl font-bold text-slate-dark mb-2" data-id="element-521">
                Contact Us
              </h2>
              <p className="text-slate-600" data-id="element-522">
                If you have any questions about these Terms & Conditions, please
                contact us at{' '}
                <a href="mailto:manishhoran123@gmail.com" className="text-primary hover:underline" data-id="element-523">
                  manishhoran123@gmail.com
                </a>
                .
              </p>
            </div>
          </motion.div>
        </div>
      </section>
    </main>;
}